import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'El tipo de equipo agrupa equipos con características similares. "Livianos", "Pesados", "De transporte", "De mantenimiento", etc.',
    'No confundir con la familia: la familia agrupa por clase de equipo para informes y filtros.',
    'Conviene definir pocos tipos y bien diferenciados; si dos tipos se usan igual, unificalos.',
  ],
  nextSteps: [
    'Asignar el tipo a cada equipo desde su ficha.',
    'Los informes permiten filtrar y comparar resultados por tipo de equipo.',
  ],
};

const ConfiguracionTiposEquipo = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="tipos"
      titulo="Tipos de Equipo"
      descripcion="Categorías de equipos disponibles"
      icon="fas fa-cogs"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionTiposEquipo;